import React from "react";
import { SafeAreaView, Text, View, ActivityIndicator } from "react-native";

import headerStyles from "./headerStyles";
import Icons from "../../../v3/common/icons/index";
import AppConfig from "../../../../config/AppConfig";
import ImageComponent from "../../../v3/common/ImageComponent";
import ExitTutorialsButton from "./ExitTutorialsButton";
import AppTheme from "../../AppTheme";

export default function Header(props) {
  const {
    controller,
    title,
    subTitle,
    avatar,
    icon,
    returnPage,
    goBack,
    headerTitleStyle = {},
    isLoading = false,
    onIconClick = () => {},
    onTitlePressed = () => {},
    onMoreIconPressed,
    children,
    rightText,
  } = props;

  const hasReturnPage = returnPage || typeof goBack == "function";

  const onGoBack = () => {
    if (typeof goBack == "function") {
      goBack();
    } else {
      controller.goBack();
    }
  };

  const goToMore = () => {
    if (onMoreIconPressed) onMoreIconPressed();

    if (controller != null) {
      if (controller.navigation != null && AppConfig.USE_DRAWER) {
        controller.navigation.openDrawer();
      } else {
        controller.changePage("feed", { selectedPage: "more", args: {} });
      }
    }
  };

  return (
    <View style={[headerStyles.container, props.style]}>
      <View style={headerStyles.header}>
        <View style={headerStyles.titleRow}>
          <View style={headerStyles.leftContainer}>
            {hasReturnPage ? (
              <Icons.Back onPress={onGoBack} />
            ) : (
              <Icons.MenuIcon onPress={goToMore} />
            )}
          </View>

          <View style={headerStyles.titleContainer}>
            <Text
              style={[headerStyles.title, headerTitleStyle]}
              onPress={onTitlePressed}
            >
              {title}
            </Text>
          </View>

          {/* Exit tutorials */}
          <ExitTutorialsButton controller={controller} />

          {/* Right container */}
          <View style={headerStyles.rightContainer}>
            {rightText ? (
              <Text numberOfLines={2} style={headerStyles.rightText}>
                {rightText}
              </Text>
            ) : null}

            {props.iconTag ? <>{props.iconTag}</> : null}
            {props.iconTag2 ? <>{props.iconTag2}</> : null}
            {props.iconTag3 ? <>{props.iconTag3}</> : null}

            {icon || avatar ? (
              <View style={[headerStyles.imageContainer, props.avatarStyle]}>
                <ImageComponent
                  onPress={onIconClick}
                  style={icon ? headerStyles.icon : headerStyles.avatar}
                  icon={icon}
                  image={avatar}
                />
              </View>
            ) : null}
            {isLoading ? (
              <View
                style={[
                  {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    width: 40,
                    right: 0,
                    top: 0,
                    bottom: 0,
                  },
                ]}
              >
                <ActivityIndicator size="large" color={AppTheme.iconBlack} />
              </View>
            ) : null}
          </View>
        </View>

        {subTitle ? (
          <View style={headerStyles.subTitleContainer}>
            <Text numberOfLines={1} style={headerStyles.subTitle}>
              {subTitle}
            </Text>
          </View>
        ) : null}
      </View>

      {children ? (
        <View
          style={{
            marginTop: 8,
          }}
        >
          {children}
        </View>
      ) : null}
    </View>
  );
}
